import React, {useEffect, useState} from 'react';
import {SectionHelper} from '@common/ui/other/section-helper';
import {ErrorIcon} from '@ui/icons/material/Error';
import {Trans} from '@ui/i18n/trans';

export default function DetectBlockedDomain() {
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    fetch('https://darkibox.com/robots.txt', {
      method: 'GET',
      mode: 'no-cors', // important pour éviter les erreurs CORS visibles
    })
      .then(() => {
        // Même si on ne peut pas lire la réponse, ça prouve que le domaine répond
        setIsBlocked(false);
      })
      .catch(() => {
        // Si le domaine est bloqué par DNS ou autre, la requête échoue
        setIsBlocked(true);
      });
  }, []);

  return <div>{isBlocked && <AlertVideoDnsBlock />}</div>;
}
function AlertVideoDnsBlock() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const item = localStorage.getItem('alert-video-dns-block3');
    if (item) {
      try {
        const {timestamp} = JSON.parse(item);
        const now = Date.now();
        const threeDays = 3 * 24 * 60 * 60 * 1000;

        if (now - timestamp >= threeDays) {
          // 3 jours se sont écoulés, on réaffiche
          setVisible(true);
        } else {
          // encore dans la période de blocage
          setVisible(false);
        }
      } catch (e) {
        // si parsing échoue, on affiche quand même
        setVisible(true);
      }
    } else {
      // aucune donnée enregistrée, on affiche
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(
      'alert-video-dns-block3',
      JSON.stringify({timestamp: Date.now()}),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <SectionHelper
      className="mt-24"
      color="warning"
      leadingIcon={<ErrorIcon size="xs" className="text-danger" />}
      onClose={handleClose}
      title={
        <>
          <Trans message="DNS blocking" />?
        </>
      }
      description={
        <>
          <span className="text-sm font-semibold text-warning">
            <Trans message="It seems the domain is blocked by your ISP" />.{' '}
          </span>
          <a
            className="mr-4 text-primary underline"
            href="https://changetondns.fr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans message={'change your DNS'} />
          </a>
        </>
      }
    />
  );
}
